$(document).ready(function () {
    if($(window).width()>768) {
        $(".desktop_upsell").append('<div id="infiniteoptions-container"></div>');
    }
    else {
        $(".mobile_upsell").append('<div id="infiniteoptions-container"></div>');
    }

    $(".single_va_img").each(function(){
        $(this).click(function(){
            var option = $(this).attr("alt").split(" /")[0];
            var option_id = $(this).attr("var_id")
            $("span#ProductPrice").text($(this).attr("price"))
            $("select#productSelect-option-0 option").each(function(){
                if($(this).text() == option) {
                    $("#productSelect-option-0").val(option);
                    $(this).click();
                    $(this).select();
                    console.log($(this).text())
                    console.log(option_id)
                }
            })
            $("#productSelect option").each(function() {
                if($(this).val() == option_id) {
                    if($(this).attr("disabled") == "disabled") {
                        $("div#booster-button").show();
                        $('#AddToCart').addClass('disabled').prop('disabled', true);
                        $('#AddToCartText').text("Sold Out");
                        $('.quantity-selector, label + .js-qty').hide();
                    }
                    else {
                        $("div#booster-button").hide();
                        $('#AddToCart').removeClass('disabled').prop('disabled', false);
                        $('#AddToCartText').text("Add to Cart");
                        $('.quantity-selector, label + .js-qty').show();
                        $(this).prop("selected", true)
                    }
                }
                else {
                    $(this).prop("selected", false)
                }
            })
        })
    })

    var timer = setInterval(() => {
        if($("label.spb-productdescfont.spb-productdesctextcolor").length > 0){
            $("fieldset label").each(function() {
                if($(this).text().indexOf("SOLD OUT") != -1) {
                    $(this).find(".spb-productoptiontextcolor").attr("disabled", true);
                }
            })
            $("label.spb-productdescfont.spb-productdesctextcolor").text("Do you need a Shaving Brush? Click Here.")
            $("label.spb-productdescfont.spb-productdesctextcolor").click(function(){
                $("fieldset").toggle();
            })
          clearInterval(timer)
        }
      }, 200);

    var timer2 = setInterval(() => {
        if($("section.mrp-related-products-section").length > 0) {
            $("limespot-box[data-box-type='Related']").hide()
            clearInterval(timer2)
        }
    }, 200)
});